// // import React from "react";

// // const DateFormatter = ({ dateString }) => {
// //   const formatDate = (dateString) => {
// //     if (!dateString) {
// //       return "Not Available";
// //     }
// //     const date = new Date(dateString);
// //     const year = date.getFullYear();
// //     const month = date.getMonth() + 1;
// //     const day = date.getDate();
// //     return `${year}-${month}-${day}`;
// //   };

// //   return <>{formatDate(dateString)}</>;
// // };

// // export default DateFormatter;

// const formatDate = (dateString) => {
//   if (!dateString) {
//     return "Not Available";
//   }

//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) {
//     return "Invalid Date";
//   }

//   // const date = new Date(dateString);
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   const hours = String(date.getHours() - 1).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");
//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

// export default formatDate;

// const formatDate = (dateString) => {
//   if (!dateString) {
//     return "Not Available";
//   }

//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) {
//     return "Invalid Date";
//   }

//   // const date = new Date(dateString);
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   const hours = String(date.getHours() - 1).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");
//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

// export default formatDate;

// const formatDate = (dateString) => {
//   if (!dateString) {
//     return "Not Available";
//   }

//   const date = new Date(dateString);
//   // console.log("date", date);
//   if (isNaN(date.getTime())) {
//     return "Invalid Date";
//   }

//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   const hours = String(date.getHours()).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");

//   // Return in 'd-m-Y H:i:s' format
//   return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
//   // return `${day}-${month}-${year}`;
// };

// const formatDate = (dateString) => {
//   if (!dateString) {
//     return "Not Available";
//   }

//   const date = new Date(dateString);

//   // Check if the date is valid
//   if (isNaN(date.getTime())) {
//     return "Invalid Date";
//   }

//   // Get UTC components
//   const year = date.getUTCFullYear();
//   const month = String(date.getUTCMonth() + 1).padStart(2, "0");
//   const day = String(date.getUTCDate()).padStart(2, "0");
//   const hours = String(date.getUTCHours()).padStart(2, "0");
//   const minutes = String(date.getUTCMinutes()).padStart(2, "0");
//   const seconds = String(date.getUTCSeconds()).padStart(2, "0");

//   // Return in 'd-m-Y H:i:s' format
//   return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
// };

// The API base URL is inlined at build time, so this is fixed per build
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").trim();
export const IS_JOATECH_GLOBAL = API_BASE_URL.includes("api.joatechglobal.com");

const ONE_HOUR_MS = 60 * 60 * 1000;

// keepTime = true: never alter the time component, whatever the endpoint.
// Otherwise one hour is added when running against the joatechglobal API.
const formatDate = (dateString, includeTime = true, keepTime = false) => {
  const shiftHour = IS_JOATECH_GLOBAL && !keepTime;

  if (!dateString) {
    return "Not Available";
  }

  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Short month names
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Strings like "2025-09-07 09:45:10" or "2025-09-07T09:45:10.000000Z":
  // print the numbers exactly as the API sent them, with no timezone conversion
  const parts =
    typeof dateString === "string" &&
    dateString.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (parts && months[Number(parts[2]) - 1]) {
    let [, y, mo, d, h = "00", mi = "00", s] = parts;
    // Only shift when the string actually carries a time; the date rolls over if needed
    if (shiftHour && parts[4] !== undefined) {
      const t = new Date(
        Date.UTC(+y, +mo - 1, +d, +h, +mi, +(s || 0)) + ONE_HOUR_MS
      );
      const pad = (n) => String(n).padStart(2, "0");
      y = String(t.getUTCFullYear());
      mo = pad(t.getUTCMonth() + 1);
      d = pad(t.getUTCDate());
      h = pad(t.getUTCHours());
      mi = pad(t.getUTCMinutes());
      if (s !== undefined) s = pad(t.getUTCSeconds());
    }
    const datePart = `${d}-${months[Number(mo) - 1]}-${y}`;
    if (!includeTime) return datePart;
    // Seconds are optional (e.g. "2026-10-07T10:59"): show them only if sent
    if (parts[4] === undefined) return `${datePart} 00:00:00`;
    return `${datePart} ${h}:${mi}${s !== undefined ? `:${s}` : ""}`;
  }

  // Non-ISO input: fall back to the Date object
  if (shiftHour) date.setTime(date.getTime() + ONE_HOUR_MS);

  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  // Return date only (23-Nov-2025)
  if (!includeTime) {
    return `${day}-${month}-${year}`;
  }

  // Return date with time (original format)
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export default formatDate;
